module.exports = __webpack_public_path__ + "img/JobsHeader.4c540a7e.jpg";